module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagValueAutocomplete.tagValue.label":"Value"}}')
  delete Component.options._Ctor
}
